import React from 'react';
import { FieldArray, FormSection } from 'redux-form';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import { CLIENT_PAYROLL_RULES_GROUP_LIST } from 'src/constants/EndpointUrls';
import { TextField } from 'src/jbc-front/components/Form';
import { LabelMapper } from 'jbc-front/components/FormErrors';
import { isThaiMoney } from 'src/utils/CustomValidators';
import { getEmployeeFormValues } from 'src/reducers/employees/employees';
import selector from 'src/utils/Utils';
import { getSelectOptions } from 'src/reducers/selectOptions';

import styles from './EmployeeAllowancesSection.scss';

const EmployeeAllowanceItem = ({ formKey, itemInfo, payrollRuleGroup }) => {
  const isSemiMonthlyPayment = payrollRuleGroup.paymentCount === 'twice';
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <FormSection name={formKey}>
        <div>
          <TextField
            name="allowanceAmount"
            yen
            validate={isThaiMoney}
            label={
              isSemiMonthlyPayment
                ? `${itemInfo.clientAllowanceName}(${t('features.PayrollRulesGroups.components.EmployeeAllowanceSection.first_half')})`
                : itemInfo.clientAllowanceName
            }
          />
          {isSemiMonthlyPayment && (
            <TextField
              name="allowanceAmountSecondHalf"
              yen
              validate={isThaiMoney}
              label={`${itemInfo.clientAllowanceName}(${t('features.PayrollRulesGroups.components.EmployeeAllowanceSection.second_half')})`}
            />
          )}
          <LabelMapper name="allowanceAmount" label={t('features.PayrollRulesGroups.components.EmployeeAllowanceSection.amount_is')} />
        </div>
      </FormSection>
    </React.Fragment>
  );
};

let EmployeeAllowances = ({ fields, selectedPayrollGroupId, payrollRulesGroups, dispatch }) => {
  const { t } = useTranslation();
  const selectedPayrollRuleGroup = _.find(payrollRulesGroups, { id: selectedPayrollGroupId });

  return (
    <div className={styles.wrap}>
      {fields.map((item, index) => {
        const employeeAllowance = fields.get(index);
        if (employeeAllowance.clientPayrollRulesGroupId === selectedPayrollGroupId) {
          return (
            <EmployeeAllowanceItem
              formKey={item}
              key={item}
              itemInfo={employeeAllowance}
              payrollRuleGroup={selectedPayrollRuleGroup}
              dispatch={dispatch}
            />
          );
        }
        return undefined;
      })}
      {_.filter(fields.getAll(), { clientPayrollRulesGroupId: selectedPayrollGroupId }).length === 0 && (
        <p>
          {t('features.Employees.components.EmployeeAllowancesSection.no_configurable_item')}
          <a href={CLIENT_PAYROLL_RULES_GROUP_LIST} className="u-txt-link">
            {t('features.Employees.components.EmployeeAllowancesSection.salary_rule')}
          </a>
          {t(
            'features.Employees.components.EmployeeAllowancesSection.Will_be_displayed_if_registered_Amount_setting_Allow_amount_setting_in_employee_list_in_provision_and_deduction_items'
          )}
        </p>
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  selectedPayrollGroupId: selector(getEmployeeFormValues(state), 'employeePayrollRule', 'clientPayrollRulesGroupId'),
  payrollRulesGroups: getSelectOptions(state, 'payrollRulesGroups')
});

EmployeeAllowances = connect(mapStateToProps)(EmployeeAllowances);

const EmployeeAllowancesSection = () => {
  const { t } = useTranslation();
  return (
    <div>
      <h4>{t('features.Employees.components.EmployeeAllowancesSection.provision_and_deduction_items_setting')}</h4>
      <FieldArray name="employeeAllowances" component={EmployeeAllowances} />
    </div>
  );
};

export default EmployeeAllowancesSection;
